<script lang="ts">
    import { fade } from "svelte/transition"
    // @ts-ignore
    import { scrollToTop } from "svelte-scrollto"
    import { Router, Route, links } from "../../../vendor/svelte-routing"

    import Header from "./layout/Header.svelte"
    import BreadCrumb from "./layout/Breadcrumb.svelte"
    import Footer from "./layout/Footer.svelte"
    import Home from "./routes/Home.svelte"
    import MyOrdersRequest from "./routes/MyOrdersRequest.svelte"
    import MyOrders from "./routes/MyOrders.svelte"
    import MyOrderDetails from "./routes/MyOrderDetails.svelte"
    import Service from "./routes/Service.svelte"
    import Product from "./routes/Product.svelte"
    import Checkout from "./routes/Checkout.svelte"
    import ArrowUpIcon from "svelte-material-icons/ArrowUp.svelte"
    import {
        content,
        iframeView,
        location,
        contentOverlay,
        dealerLoginOverlay,
        mobileSearchOverlay,
        cartOverlay,
        theme,
        login,
        openModal,
    } from "../store"
    import Category from "./routes/Category.svelte"
    import HeroSlider from "./slider/HeroSlider.svelte"
    import ContentBlocks from "./layout/ContentBlocks.svelte"
    import { apiBaseURL, title } from "../config"
    import Search from "./routes/Search.svelte"
    import OfferAssistantPage from "./routes/category/OfferAssistant/OfferAssistantPage.svelte"
    import MobileSearchForm from "./layout/MobileSearchForm.svelte"
    import DealerLoginOverlay from "./layout/DealerLoginOverlay.svelte"
    import ContentOverlay from "./layout/ContentOverlay.svelte"
    import CartOverlay from "./layout/CartOverlay.svelte"
    import OrderRating from "./routes/OrderRating.svelte"
    import RatingConfirm from "./routes/RatingConfirm.svelte"
    import SsrSkip from "./SsrSkip.svelte"
    import Properties from "./layout/Properties.svelte"
    import DealerLoginMessage from "./layout/DealerLoginMessage.svelte"
    import { onMount } from "svelte"
    import Notifications from "./widgets/Notifications.svelte"

    export let url = ""

    if (url) {
        // ssr
        let l = url.split("?")
        $location = {
            path: l[0],
            search: l.length > 1 ? l[1] : "",
            hash: "",
            categoryPath: l[0].replace(/\/[^_\/]+_[^\/]+$/, ""),
            push: false,
            pop: false,
        }
    }

    let scrollY: number

    let oldPath: string
    location.subscribe((l) => {
        if (l.push && oldPath != l.path) scrollToTop()
        oldPath = l.path
    })

    if (typeof window !== "undefined") console.log("App initialized")

    // Theme
    theme.subscribe((theme) => {
        if (typeof document !== "undefined") {
            document.querySelector("html")?.setAttribute("data-theme", theme)
        }
    })

    // Customized Theme
    // let themeCSSVariables
    // customizedThemeVariables.subscribe((vars) => {
    //     themeCSSVariables = vars.join(";")
    // })

    // check for dealerLoginMessage session storage state
    $: if ($login) {
        if (typeof window !== "undefined") {
            const dealerLoginMessage = sessionStorage.getItem("dealerLoginMessage")
            if (!dealerLoginMessage) {
                $contentOverlay = {
                    component: DealerLoginMessage,
                    hideClose: true,
                }
            }
        }
    }

    onMount(() => {
        const updateModalState = () => {
            $openModal = document.getElementsByClassName("dialog-open").length > 0
        }
        const interval = setInterval(updateModalState, 100)
        return () => clearInterval(interval)
    })
</script>

<svelte:window bind:scrollY />

<!-- <div style="{themeCSSVariables}" use:links> -->
<div use:links>
    {#if !$iframeView}
        <Header />
    {/if}

    {#if $mobileSearchOverlay}
        <MobileSearchForm />
    {/if}

    {#if $cartOverlay}
        <CartOverlay />
    {/if}

    {#if $dealerLoginOverlay}
        <DealerLoginOverlay />
    {/if}

    {#if $contentOverlay}
        <ContentOverlay bind:content="{$contentOverlay}" />
    {/if}

    <div id="{$iframeView ? 'iframe_wrapper' : 'site_wrapper'}">
        {#if !$iframeView}
            <BreadCrumb />
            <HeroSlider />
        {/if}
        {#if $content}
            <ContentBlocks imageBase="{apiBaseURL + '/content/' + $content.id + '/'}" blocks="{$content.top}" />
        {/if}

        <Router {url}>
            <Route path="/service/*" component="{Service}" />
            <Route path="/checkout/*" component="{Checkout}" />
            <Route path="/order" component="{MyOrdersRequest}" />
            <Route path="/order/rating/*params" component="{OrderRating}" />
            <Route path="/order/rating/confirm/*params" component="{RatingConfirm}" />
            <Route path="/order/:token" component="{MyOrders}" />
            <Route path="/order/:token/:id" component="{MyOrderDetails}" />
            <Route path="/search" component="{Search}" />
            <Route path="/brief-und-paketkaesten/konfigurator" component="{OfferAssistantPage}" />
            <Route path="/" component="{Home}" />
            <Route path="/*path" let:params>
                {#if params.path?.match(/^([^\/]+\/)*[^_/]+_/)}
                    <Product code="{params.path.match(/^([^\/]+\/)*([^_\/]+)_/)[2]}" />
                {:else}
                    <Category />
                {/if}
            </Route>
        </Router>

        {#if $content}
            <ContentBlocks imageBase="{apiBaseURL + '/content/' + $content.id + '/'}" blocks="{$content.bottom}" />
        {/if}
        {#if $location.path.length <= 1}
            <Properties />
        {/if}

        {#if !$iframeView}
            <Footer />
        {:else}
            <div class="footer">
                Powered by <img src="media/renz-logo.png" alt="Renz Shop" />
                <a
                    href="/service/impressum"
                    on:click|preventDefault="{() => {
                        $contentOverlay = '/service/impressum'
                    }}">Impressum</a
                >
                <a
                    href="/service/datenschutz"
                    on:click|preventDefault="{() => {
                        $contentOverlay = '/service/datenschutz'
                    }}">Datenschutz</a
                >
            </div>
        {/if}
    </div>

    {#if scrollY > 1000}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="scrolltop"
            transition:fade="{{}}"
            on:click="{() => {
                scrollToTop()
            }}"
        >
            <ArrowUpIcon />
        </div>
    {/if}
</div>
<SsrSkip />
<Notifications />

<style lang="less" global>
    @import "../css/main.less";
    @import "../css/variables.less";
    #site_wrapper {
        padding-top: var(--navheight_mobile);
        @media (min-width: @res-desktop) {
            padding-top: var(--navheight);
        }
        .transition();
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        justify-content: space-between;
    }

    .video-overlay {
        padding-top: var(--navheight);
    }

    .scrolltop {
        position: fixed;
        right: 20px;
        bottom: 20px;
        width: 40px;
        height: 40px;
        background: var(--primary);
        color: var(--on-primary);
        border-radius: 100%;
        -webkit-border-radius: 100%;
        -moz-border-radius: 100%;
        .flex();
        align-items: center;
        justify-content: center;
        z-index: 2000;
        cursor: pointer;
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        @media @desktop {
            .opacity(0.6);
            bottom: 30px;
            right: 30px;
            &:hover {
                .opacity(1);
            }
        }
    }

    #iframe_wrapper {
        .footer {
            position: absolute;
            top: 0;
            right: 0;
            font-size: 0.7em;
            padding: 5px 10px;

            img {
                height: 18px;
                width: auto;
                vertical-align: middle;
                margin-left: 5px;
            }

            a {
                color: inherit;
                text-decoration: underline;
                margin-left: 10px;
            }
        }
    }
</style>
